import type { VariableValues } from '@hooks/useVariables';

import type RootStore from '@stores/root.store';

export type VariableState = Map<string, VariableValues[]>;

export type Variable = {
  id: number;
  name: string;
  type: string;
};

export class VariablesStore {
  constructor(public rootStore: RootStore) {}
}
